export const ACCESS_TOKEN_KEY = 'authToken'
export const ID_TOKEN_KEY = 'idToken'
export const TOKEN_CUSTOM_NAMESPACE = 'https://vtms-apps/'
export const AUTH_AUDIENCE = 'https://vtms-apps/'
export const AUTH_DOMAIN = 'vtms.eu.auth0.com'
export const AUTH_CLIENT_ID = 'AYTsnW7kImdmrrDVRtf1f0yVAuy8xnhF'